/* eslint-disable import/prefer-default-export */
import { useInfiniteQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { InsightsEvent, PaginatedResponse } from 'dashboard/types';

function getPathWithQuery(fullUrl: string): string {
  const url = new URL(fullUrl);
  return `${url.pathname}${url.search}`;
}

export function useInsightsEvents(queryParams: string) {
  return useInfiniteQuery<PaginatedResponse<InsightsEvent>>({
    queryKey: [APIKey.INSIGHTS_EVENTS, queryParams],
    queryFn: ({ pageParam }) =>
      baseFetcher(
        pageParam
          ? getPathWithQuery(pageParam as string)
          : `${apiRoutes.insightsEvents()}?${queryParams}`
      ),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.next,
  });
}
